import { createContext, useState, useEffect } from "react";
import client from "../api/axios_client";

export const AuthContext = createContext(null);

export default function AuthProvider({ children }) {
  const [user, setUser]       = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (!token) { setLoading(false); return; }
    if (token.startsWith("mock_")) {
      try { setUser(JSON.parse(localStorage.getItem("mock_user") || "null")); } catch {}
      setLoading(false);
      return;
    }
    client.get("/auth/me")
      .then((r) => setUser(r.data?.data ?? r.data))
      .catch(() => localStorage.removeItem("access_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = (token, userData) => {
    localStorage.setItem("access_token", token);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("mock_user");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
